import { Box, styled } from '@mui/material';

export const RootAssemblyPill = styled(Box)(({ theme }) => ({
  background: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  borderRadius: 12,
  padding: '2px 6px',
  fontWeight: 600,
  textTransform: 'uppercase',
  zIndex: 2,
  pointerEvents: 'none',
  lineHeight: 1,
  fontSize: '0.5rem',
  display: 'inline-block',
  whiteSpace: 'nowrap',
  flexShrink: 0,
}));
